import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ITasksRes } from 'modules/shared/models/task.models';

import { environment } from 'environment/environment';
import { BaseListReqParams } from 'modules/shared/models/base.models';

@Injectable()
export class TasksService {

  readonly apiBase: string = environment.API_BASE;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get list of tasks for this user
   * @method getTasks
   */
  getTasks(taskType: string, payload?: BaseListReqParams): Observable<ITasksRes> {
    let params: HttpParams = new HttpParams();
    const url: string = this.apiBase + `/api/tasks/?status=${taskType}`;

    if (payload) {
      Object.entries(payload).forEach(([key, value]: [string, any]) => {
        if (value !== undefined) {
          params = params.append(key, value);
        }
      });
    }

    return this.httpClient.get<ITasksRes>(url, {params: params});
  }
}
